<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 40px">
      <Loading></Loading>
    </div>
    <v-container
      v-else
      class="Kanit px-5"
      grid-list-xs
      style="padding-bottom: 80px; position: relative"
    >
      <div>
        <div class="mb-3">
          <div class="text-center">
            <h2 style="color: #0c4d9d" class="mb-0">สรุปคำสั่งซื้อ</h2>
          </div>
        </div>
        <div style="font-size: 14px">
          <div class="mt-2">
            <b>ลูกค้า</b>
            : {{ customer_name }}
          </div>
          <div style="font-weight: 600">ที่อยู่ในการขนส่ง</div>
          <div>{{ customer_address }}</div>
          <div>
            <b>ส่งโดย</b>
            :
            <span v-if="productdetail.shippingtype == 'scgexpress'">
              <img
                style="height: 50%; width: 64px"
                src="../assets/scgexpress.png"
              />
            </span>
            <span v-else>ร้านค้าส่งเอง</span>
          </div>
          <div>
            <b>ช่องทางการจ่ายเงิน</b>
            : เครดิต/เดบิต
          </div>
        </div>
        <div>
          <table class="quotationtable" style="width: 100%" cellspacing="0">
            <tr style="margin-bottom: 20px">
              <th class="borderbot detailtable">รายละเอียดสินค้า</th>
              <th class="borderbot quantitytable">จำนวน</th>
              <th class="borderbot pricetable">ราคา</th>
            </tr>
            <tr>
              <td style="height: 10px; border: none"></td>
            </tr>
            <tr v-for="(item, k) in productdetail.productlist" :key="item.id">
              <td
                style="
                  font-size: 11px;
                  padding-bottom: 10px;
                  border-bottom: 1px solid #b9b9b9;
                "
                :class="
                  (products.length == k + 1 ? 'borderbot' : '') + ' text-left'
                "
                class="detailtable"
              >
                {{ item.material }}
                {{ item.sales_text_th }} ขนาด {{ item.size }} สี
                {{ item.shade }}
              </td>
              <td
                style="
                  font-size: 11px;
                  padding-bottom: 10px;
                  border-bottom: 1px solid #b9b9b9;
                "
                :class="products.length == k + 1 ? 'borderbot' : ''"
                class="quantitytable"
              >
                {{ item.quantity }}
                <span style="margin-left: 5px">ถัง</span>
              </td>
              <td
                style="
                  border-right: none;
                  font-size: 11px;
                  padding-bottom: 10px;
                  border-bottom: 1px solid #b9b9b9;
                "
                :class="products.length == k + 1 ? 'borderbot' : ''"
                class="pricetable"
              >
                {{ parseFloat(item.price) * parseFloat(item.quantity) }}
              </td>
            </tr>
            <tr>
              <td style="border-top: 1px solid black" class="py-2"></td>
              <td
                class="py-2"
                style="font-size: 11px; border-top: 1px solid black"
              >
                ค่าขนส่ง
              </td>
              <td
                class="py-2"
                style="
                  border: none;
                  font-size: 11px;
                  border-top: 1px solid black;
                "
              >
                {{ productdetail.shippingcharge }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td style="font-size: 11px">ราคารวม</td>
              <td style="border: none; font-size: 11px">
                {{ productdetail.total }}
              </td>
            </tr>
          </table>
        </div>

        <div @click="confirmPrice" v-ripple class="addcartbtn Kanit myshadow">
          <div v-if="!saveloading">
            <p v-if="productdetail.shippingtype == 'scgexpress'">
              เรียกรถรับสินค้า
            </p>
            <p v-else>ยืนยันการจัดส่งสินค้า</p>
          </div>
          <div v-else>
            <v-progress-circular
              indeterminate
              size="35"
              color="white"
            ></v-progress-circular>
          </div>
        </div>
      </div>
      <v-dialog v-model="showTracking" persistent>
        <v-card>
          <div class="ma-1 text-right">
            <v-btn @click="close" icon small>
              <v-icon small>close</v-icon>
            </v-btn>
          </div>
          <div class="pa-2 Kanit">
            <ValidationObserver ref="trackingobserver" tag="form">
              <ValidationProvider
                name="เลข Tracking"
                :rules="{
                  required: true,
                }"
                v-slot="{ errors }"
              >
                <v-text-field
                  outlined
                  dense
                  placeholder="กรอกเลข Tracking"
                  v-model="trackingno"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </ValidationObserver>
            <div class="text-center">
              <v-btn
                :loading="trackingloading"
                @click="saveTracking"
                rounded
                dense
                dark
                color="#0c4d9d"
                >บันทึก</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import UploadFile from "@/components/UploadProfile";
import moment from "moment";
import Loading from "@/components/Loading.vue";

export default {
  data() {
    return {
      trackingloading: false,
      showTracking: false,
      trackingno: "",
      showConfirm: false,
      productdetail: {},
      customer_name: "",
      customer_address: {},
      transitionname: "slidedealer",
      loading: true,
      radios: "",
      saveloading: false,
      storeshippingprice: "",
      shippingprice: "",
      products: [],
      data2: "",
    };
  },
  components: {
    Loading,
    UploadFile,
  },
  computed: {
    formatedShippingprice() {
      if (this.radios == "scgexpress") {
        return this.shippingprice;
      } else if (this.radios == "storeshipping") {
        return this.storeshippingprice;
      } else return 0;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    sumprice() {
      return this.products.reduce((a, b) => {
        return a + (b.price ? parseFloat(b.price) : 0) * parseFloat(b.quantity);
      }, 0);
    },
  },
  async mounted() {
    // await this.checkTransaction();
    await this.getOrder();
    // await this.calculateprice();
    await this.sendMessageToCustomer();
    this.loading = false;
  },
  methods: {
    close() {
      this.showTracking = false;
      this.trackingno = "";
    },
    sendMessageToCustomer() {
      return new Promise((resolve) => {
        var vm = this;
        var data = {
          order_number: vm.query.order_number,
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/sendmessageorderreadytoshiptocustomer",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              resolve();
            } else {
              await vm.$swal.fire({
                text: response.data.reason,
              });
              vm.$liff.closeWindow();
            }
          });
      });
    },
    //   var isValid = await this.$refs.trackingobserver.validate();
    // await this.saveTrackingNo();
    checkTime() {
      var vm = this;
      var format = "hh:mm:ss";

      var time = moment(),
        beforeTime = moment("00:00:00", format),
        afterTime = moment("10:59:00", format);
      return new Promise((resolve) => {
        if (!time.isBetween(beforeTime, afterTime)) {
          this.$swal
            .fire({
              text: "สามารถเรียกรถได้ไม่เกิน 11 โมงเท่านั้น",
            })
            .then(async (result) => {
              if (vm.query.apptype == "line") {
                await vm.$liff.closeWindow();
                resolve();
              }
            });
        } else {
          resolve();
        }
      });
    },
    getOrder() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toashowpayments", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: this.query.pageid,
              customerid: this.query.customerid,
              order_number: this.query.order_number,
            },
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });

              vm.query.view = "OrderView";

              return;
            } else if (response.data.responsecode == 200) {
              this.productdetail = response.data.data[0].productdetail;
              var sumquantity = this.productdetail.productlist.reduce(
                (a, b) => a + parseFloat(b.quantity),
                0
              );
              Object.assign(this.query, { quantity: sumquantity });
              this.customer_name = response.data.data[0].customer_name;
              this.$store.state.shippingtype = this.productdetail.shippingtype;
              var address = response.data.data[0].customer_address;
              var fulladdress =
                address.address1 +
                " แขวง" +
                address.sub_district +
                " เขต" +
                address.district +
                " จังหวัด" +
                address.province +
                " " +
                address.zip_code;
              this.customer_address = fulladdress;
              resolve();
            } else {
              await vm.$swal.fire({
                text: response.data.reason,
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            }
          });
      });
    },
    async modalconfirm() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.showConfirm = true;
      }
    },
    afterEnter: () => {
      window.scrollTo(0, 0);
    },
    afterLeave: () => {
      Store.commit("setPageTransition", "default");
    },
    back() {
      this.transitionname = "slidedealer-back";
      this.$nextTick(() => {
        this.step = 1;
      });
    },
    async calculateprice() {
      var vm = this;
      this.transitionname = "slidedealer";
      // this.saveloading = true;
      // await this.checkTransaction();

      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        customerid: this.query.customerid,
        order_number: this.query.order_number,
      };
      return new Promise((resolve) => {
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toacalculatecost",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              this.shippingprice = parseFloat(
                response.data.data[0].cost
              ).toFixed(2);
            } else {
              await vm.$swal.fire({
                text: response.data.reason,
                icon: "error",
              });
            }
            resolve();
          });
      });
    },
    async confirmPrice() {
      if (!this.saveloading) {
        var vm = this;
        var result;
        if (this.productdetail.shippingtype == "scgexpress") {
          await vm.checkTime();
          var text = "ยืนยันการเรียกรถ";
          result = await vm.$swal.fire({
            icon: "question",
            showCancelButton: true,
            cancelTextButton: "ไม่",
            confirmTextButton: "ใช่",
            text: text,
          });
          if (result.value) {
            vm.query.view = "ShippingCar";
          }
        } else {
          this.showTracking = true;
        }
      }
    },
    saveTracking() {
      var vm = this;
      if (!vm.trackingloading) {
        vm.trackingloading = true;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype, // มาจาก param ใน liff ordersummary
          pageid: vm.query.pageid, // มาจาก param ใน liff ordersummary
          customerid: vm.query.customerid, // มาจาก param ใน liff ordersummary
          order_number: vm.query.order_number, // มาจาก param ใน liff ordersummary
          trackingno: vm.trackingno, // field กรอกข้อมูล
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaconfirmshipment",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xx xxx",
              },
            }
          )
          .then(async (response) => {
            vm.trackingloading = false;
            vm.showTracking = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.smallpriceinput.v-text-field input {
  font-size: 12px;
}
.smallpriceinput .v-input__slot fieldset {
  height: 27px;
}
.smallpriceinput .v-input__slot div {
  height: 21px;
}
.radiosmallfont .v-label {
  font-size: 12px;
}
.compact-form.v-text-field input {
  font-size: 24px;
}
.compact-form .v-messages__message {
  font-size: 15px;
}
.compact-form.v-text-field label {
  font-size: 24px;
}
.compact-form {
  transform: scale(0.655);
  transform-origin: left;
}
$duration: 0.5s;
.transition {
  overflow: hidden;
}
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
table.quotationtable .borderbot {
  border-bottom: 1px solid #b9b9b9;
}
table.quotationtable td {
  text-align: center;
  border-right: 1px solid #b9b9b9;
}
table {
  margin-top: 40px;
}
.detailtable {
  width: 60% !important;
  padding-left: 6px;
  padding-right: 6px;
}
.quantitytable {
  width: 20% !important;
}
.pricetable {
  width: 20% !important;
}
</style>